var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "mC" } }, [
      _c("div", { attrs: { id: "header" } }, [
        _c("div", { attrs: { id: "menuContainerL", title: "Home" } }, [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showHeader,
                expression: "showHeader"
              }
            ],
            attrs: { id: "iconHome", src: "/dist/logo-header2.png" },
            on: { click: _vm.btnHome }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showHeader,
                expression: "showHeader"
              }
            ],
            attrs: { id: "menuContainerR" }
          },
          [
            _c(
              "span",
              { attrs: { id: "menuPedido" }, on: { click: _vm.btnCliente } },
              [_vm._v(_vm._s(_vm.nombreCliente))]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.itemsCarrito != 0,
                    expression: "itemsCarrito!=0"
                  }
                ],
                attrs: { id: "carritoItemsGlobe" },
                on: { click: _vm.btnCarrito }
              },
              [
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.itemsCarrito != 0,
                        expression: "itemsCarrito!=0"
                      }
                    ],
                    staticStyle: {
                      color: "#4969B2",
                      "font-weight": "500",
                      "font-size": "12px"
                    },
                    attrs: { id: "carritoCantItem" }
                  },
                  [_vm._v(_vm._s(_vm.itemsCarrito))]
                )
              ]
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "icon",
              attrs: { id: "iconCarrito", src: "/dist/carrito.svg" },
              on: { click: _vm.btnCarrito }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown",
                on: {
                  mouseover: _vm.showDropUsuario,
                  mouseleave: _vm.hideDropUsuario
                }
              },
              [
                _c("span", { attrs: { id: "usuario" } }, [
                  _vm._v(_vm._s(_vm.nombreUsuario))
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "avatarGlobe" } }, [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "#4969B2",
                        "font-weight": "700",
                        "font-size": "18px"
                      },
                      attrs: { id: "avatarChar" }
                    },
                    [_vm._v(_vm._s(_vm.letraNombreUsuario))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.dropUsuario,
                        expression: "dropUsuario"
                      }
                    ],
                    staticClass: "dropdown-content-b"
                  },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "configuracion" } } },
                      [_vm._v("Cambiar contraseña")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "separator-menu" }),
                    _vm._v(" "),
                    _c("router-link", { attrs: { to: _vm.ctacte } }, [
                      _vm._v("Cuenta Corriente")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "separator-menu" }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "#cerrar" },
                        on: { click: _vm.cerrarSesion }
                      },
                      [_vm._v("Cerrar sesión")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "separator" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4905682b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4905682b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4905682b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/header.vue
// module chunks = 0